import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {FileItem, FileUploader} from 'ng2-file-upload';
import {FileSaverService} from 'ngx-filesaver';
import {BaseUploaderComponent} from '../../Core/Abstract/baseUploader.component';

@Component({
  selector: 'resendInvitationAttachment',
  templateUrl: 'resendInvitationAttachment.component.html',
})
export class ResendInvitationAttachmentComponent extends BaseUploaderComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload: any;
  public base64File: string | null = null;
  public continueWithSearch: boolean = true;
  @Input() debtorId: any;
  error: any;
  success: any;
  resultType: any;
  _FileSaverService: FileSaverService = inject(FileSaverService);
  constructor(
    public securityService: SecurityService,
    public configService: ConfigService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
  ) {
    super(securityService, configService, logger, visualsService, eventsEmitterService);
    this.getVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.getVisuals();
      },
    });
  }

  @Output() refreshTableAfterSuccess: EventEmitter<any> = new EventEmitter<any>();

  public initLoader() {
    this.group = 'uploadFiles';
    this.URL = this.configService.getServer() + 'ResendInvitationService/saveMultipleIvitations';
    this.displayAllowedMimeType = [''];
    this.allowedMimeType = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    this.uploader = new FileUploader({
      url: this.URL,
      headers: [
        {name: 'Accept', value: 'application/json'},
        {name: 'Content-Type', value: 'application/json; charset=utf-8'},
      ],
      authToken: 'Bearer ' + this.securityService.getFromStorage('access_token'),
      allowedMimeType: this.allowedMimeType,
      maxFileSize: this.maxFileSize,
      queueLimit: this.queueLimit,
      disableMultipart: true,
      formatDataFunctionIsAsync: true,
      formatDataFunction: async (item) => {
        return new Promise((resolve) => {
          resolve({
            dbtrId: this.debtorId,
            mimeType: this.allowedMimeType[0],
            fileName: item.file.name,
            file: this.base64File,
          });
        });
      },
    });
    this.uploader.onErrorItem = (item, response, status, headers) =>
      this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) =>
      this.onSuccessItem(item, response, status, headers);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: any): any {
    this.success = JSON.parse(response);
    console.log(this.visuals);
    if(this.success.data.statusCode == 200 && this.success.data.foureyesType == 'FILE'){
      LogService.emitAlert({
          type: "success",
          body: this.success.message
      });
    }
    else if(this.success.data > 0){
        LogService.emitAlert({
            type: "success",
            body: this.visuals.dataSuccess + ': ' + this.success.data
        });
    }else{
        LogService.emitAlert({
            type: "danger",
            body: this.visuals.dataError
        });
    }

    this.refreshTableAfterSuccess.emit();
    this.resultType = true;
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: any): any {
    let res = JSON.parse(response);
    this.error = res;
    if (status == 415) {
      var blob = new Blob([this.s2ab(atob(res.data))], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var fileName = 'error_' + item.file.name;
      this._FileSaverService.save(blob, fileName);
    }
    this.resultType = false;
  }

  s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  ngOnChanges() {
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('debtorId', this.debtorId);
    };
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    this.convertFileToBase64(file).then((base64: string) => {
      this.base64File = base64.split(',')[1];
    });
  }

  onFileDropped(event: any): void {
    const file: File = event[0];
    this.convertFileToBase64(file).then((base64: string) => {
      this.base64File = base64.split(',')[1];
    });
  }

  convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }
}
